import { Component } from '@angular/core';

@Component({
    selector: 'no-content',
    template: `
    <div>
      <h1>404: page not found</h1>
    </div>
  `,
    standalone: false
})
export class NoContentComponent {}
